import vant from 'vant'
// import {useRouter} from 'vue-router'
/* eslint-disable */
export default {
    data:function(){
        return {
            action:{
                list:''
            },
            pagion:{
                list:[],
                page:1,
                total:15,
                limit:15
            },
            edit:{
                show:false,
            }
        }
    },
    methods:{
        _textDate(x,type){
            return u.date(x,type);
        },
        _textNull(x,def){
            let _x = u.trim(x);
            return _x?_x:(def?def:'-');
        },
        _textImage(e){
            let img = e.currentTarget;
            return u.autoImage(img);
        },
        /********************************************************
         * 下拉菜单效果
         */
        _textSelect(x,k){
            let font = this.font[k];
            x[k] = x[k] || font.def;
            let val = x[k];
            let txt = '请选择'
            let list = font.list;
            for(let i=0;i<list.length;i++){
                let v = list[i];
                if(v.val==val){
                    txt = v.txt;
                    break;
                }
            }
            return txt;
        },
        _viewSelect(e,k){
            let item = this.font[k] || {};
            if(item.show){
                return item.show = false;
            }
            item.show = true;
            let el = e.currentTarget;
            let si = this.$refs[item.id];
            si.style.top = (el.offsetTop + el.offsetHeight)+'px';
            si.style.left = el.offsetLeft + 'px';
            si.style.width = el.offsetWidth + 'px';
            //--
            this.hoverView(el,si,item);
        },
        _choiceSelect(x,d,k){
            d[k] = x.val;
            this.font[k].show = false;
        },
    },
    created: function() {
        //
        let that = this;
        this.pagionData = function(url,param,fn){
            if(!u.isObject(param)){
                param = {};
            }
            let items = that.params || {};
            for(let k in items){
                param[k] = items[k];
            }
            param.__method__ = 'pagion';
            u.post(url,param,(ret)=>{
                if(ret.code != 200){
                    return vant.Toast.fail(ret.msg);
                }
                if(u.isFunction(fn)){
                    return fn(ret);
                }
                let pagion = ret.pagion;
                if(pagion.page){
                    that.pagion.page = pagion.page;
                }
                if(pagion.list){
                    that.pagion.list = pagion.list;
                }
                if(pagion.total){
                    that.pagion.total = pagion.total;
                }
            },true);
        }
        this.editAjax = function(url,param,fn){
            let method = param.id?'edit':'add';
            param.__method__ = method;
            u.post(url, param, (ret)=>{
                if(ret.code != 200){
                    return vant.Dialog.alert({
                        title: 'System Error',
                        message: ret.msg,
                        theme: 'round-button',
                        confirmButtonText:'Close'
                    }).then(() => {});
                }
                vant.Toast.success(ret.msg);
                if(u.isFunction(fn)){
                    fn(ret);
                }
                if(param.id && ret.data){
                    let list = that.pagion.list;
                    let D = ret.data;
                    for(let i in list){
                        if(list[i].id==param.id){
                            list.splice(i,1,D);
                            break;
                        }
                    }
                    return;
                }
                if(u.isFunction(that._resetItem)){
                    that._resetItem();
                }
                that.pagion.list.unshift(ret.data);
                that.pagion.total++;
            },true);
        }
        this.removeAjax = function(url,param){
            if(!u.isObject(param)){
                param = {};
            }
            vant.Dialog.confirm({
                title: '提醒',
                message: '是否确认移除？',
            }).then(() => {
                param.__method__ = 'remove';
                u.post(url,param, (ret)=>{
                    if(ret.code!=200){
                        return vant.Toast.fail(ret.msg);
                    }
                    vant.Toast.success(ret.msg);
                    let list = that.pagion.list; 
                    for(let i in list){
                        if(list[i].id==param.id){
                            list.splice(i,1);
                            break;
                        }
                    }
                });
            });
        }
        /********************************************************
         * 弹窗鼠标滑动效果 -- (显示|隐藏)
         */
        this.hoverView = function(el,si,x){
            u.__init_mouse_status = false;
            let resetShow = ()=>{
                setTimeout(()=>{
                    x.show = u.__init_mouse_status;
                },100);
            }
            el.onmouseout = ()=>{
                u.__init_mouse_status = false;
                resetShow();
            }
            si.onmouseover = ()=>{
                u.__init_mouse_status= true;
            }
            si.onmouseout=()=>{
                u.__init_mouse_status = false;
                resetShow();
            };
        }
    }
}
